import React from 'react';
import { Nav } from 'react-bootstrap';
import { LinkContainer } from 'react-router-bootstrap';

import type { INavItemProps } from '@/types/navigation';

const NavigationItem = ({ item, onCollapseNavItem, isActive }: INavItemProps): React.ReactElement => {
  return (
    <LinkContainer to={item.to} key={item.text}>
      <Nav.Link
        eventKey={item.text}
        onClick={(e: React.MouseEvent) => {
          if (item.target === '_blank') {
            window.open(String(item.to));
            e.preventDefault();
          }
        }}
        onSelect={onCollapseNavItem}
        active={isActive}
        {...(item.target && { target: item.target })}
        {...(item.rel && { rel: item.rel })}
      >
        {item.text}
      </Nav.Link>
    </LinkContainer>
  );
};

export { NavigationItem };
